<template>
  <div>
    <div id="relen">
      <div class="comond_btn">
        <el-button  @click="handleSet('add', null)" >新增规格</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { damagedqueryBuBuHuoList, orderqueryBatchNumberById, damagedaddUpadteBuBuHuo } from '../../api'
import { mapGetters } from 'vuex'
import utils from '../../../public/utils'
export default {
  data () {
    return {
      list: [],
      total: 0,
      para: { //  查询条件
        pageIndex: 1, //  页码
        pageSize: 10 //  每页数量
      },
      dialogPara: { //  弹出框配置
        isshow: false, //  默认不显示参数
        isShowDialog: false, //  默认关闭弹出框
        title: '', //  弹出框标题
        rules: null, //  规则
      },
      form: {
        replenishBatchNumIds: [],
      },
      currentStatus: '', //  当前操作状态
      batchNumberList: [], //  批号列表
    }
  },
  computed: { //  调用退货原因跟处理方式列表数据
    ...mapGetters([
      'getprocessMode', //  处理方式
      'getreturnReason', //  补货退货原因
      'getreturnWarehouse', //  是否退回仓库
    ])
  },
  mounted() {
    this.getdamagedqueryBuBuHuoList()
  },
  methods: {
    handleSearch (type, val) { //  0.合同号, 1.处理方式, 2.退货原因, 5.分页
      console.log(type, val)
      switch(type) {
        case 5:
          this.para.pageIndex = val
          break
      }
      this.getdamagedqueryBuBuHuoList()
    },
    getdamagedqueryBuBuHuoList (bol) { // 查询不补货列表
      if (bol) {
        this.para['isReplenishment'] = bol
      } else {
        this.para['isReplenishment'] = false
      }
      let para = new URLSearchParams(this.para)
      damagedqueryBuBuHuoList(para).then(data => {
        console.log(data)
        this.list = data.data.rows
        this.total = data.data.total
      })
    },
    getorderqueryBatchNumberById (id) { //  需要补货的销售订单关联批号
      console.log(id)
      let para = new URLSearchParams()
      para.append('id', id)
      orderqueryBatchNumberById(para).then(data => {
        console.log(data)
        this.batchNumberList = data.data
      })
    },
    handleSet (type, val) { // add.新增, search.查看详情, edit.编辑, delete.删除, 1.处理, 2.发货, 3.确认收货
      console.log(type, val)
      
      // this.form = val
      this.currentStatus = type //  设置当前操作状态
      switch (type) {
        case 'add':
          this.dialogPara.title = '新增不补货入库数据填充'
          this.dialogPara.isShowDialog = true
          this.form = {}
          this.form = { //  列表数据
            orderId: '', //  订单id
            contractNumber: '', //  销售合同号
            returnReason: '', //  退货原因1破包2不合格
            batchNumberMap: [ //  需要补货的销售订单关联批号
              {
                id: '',
                orderId: '', //  订单id
                batchNumId: '', //  批号id
                salesVolume: '', //  批号销售数量
              },
            ],
            returnWarehouse: '', //  T退回仓库,F不退回仓库
            processMode: '', //  处理方式1立即补货 2 下一单补货
            cargoStatus: '' //   1.待处理,2待发货3.已发货,4已完成
          }
          this.getdamagedqueryBuBuHuoList(true) //  不补货列表
          break
      }
    },
    handleAddPara () { //  新增参数
      this.form.batchNumberMap.push(
        {
          batchNumId: '', //  批号id
          salesVolume: '', //  批号销售数量
        },
      )
    },
    handleRemovePara (item) { //  删除参数
      let dom = this.form.batchNumberMap
      if (dom.length <= 1) {
        this.$message.error('至少一个参数')
      } else {
        var index = dom.indexOf(item)
        if (index !== -1) {
          dom.splice(index, 1)
        }
      }
    },
    handleChange (type, val) { // //  下拉值改变执行的操作 'contractNumber'.销售合同号
      console.log(type, val)
      switch (type) {
        case 'contractNumber':
          
          this.getorderqueryBatchNumberById(val.orderId)
          break
        case 'locat': //  采购合同号
          console.log(val)
          break
        case 'realQuantity': //  计算价格
          if (this.form.realQuantity < this.form.totalWeight) {
            this.ishowreplenishment = true
          } else {
            this.ishowreplenishment = false
            this.form.isReplenishment = ''
          }
          break
        case 'isReplenishment':
          this.fileList.salesContractUrl = []
          this.ishowreplenishment2 = val
          break
      }
    },
    handleSucess () { //  保存
      // this.dialogPara.isShowDialog = false
      // add.新增, search.查看详情, edit.编辑, delete.删除, 1.处理, 2.发货, 3.确认收货
      switch (this.currentStatus) { //  根据当前操作状态执行对应操作
        case 'add':
          this.setdamagedaddUpadteBuBuHuo() //  补货
          break
      }
    },
    handleExit () {
      this.dialogPara.isShowDialog = false
      this.getdamagedqueryBuBuHuoList()
    },
    setdamagedaddUpadteBuBuHuo () { // 补货 'add'
      let para = new URLSearchParams()
      para.append('id', this.form.id.id)
      // para.append('returnReason', this.form.returnReason)
      para.append('returnWarehouse', this.form.returnWarehouse)
      // para.append('processMode', this.form.processMode)
      let a = {}
      this.form.batchNumberMap.forEach(item =>{
        console.log(item)
        item.batchNumId = parseInt(item.batchNumId)
        a[item.batchNumId] = item.salesVolume
      })
      // para.append('orderSupervisorId', this.form.orderSupervisorId) //  如果下一单补货需要下一单的id
      para.append('batchNumberMap', JSON.stringify(a) )
      console.log(para)
      damagedaddUpadteBuBuHuo(para).then(data => {
        console.log(data)
        this.handletips(data)
      })
    },
    handletips (data) { //  操作成功或者失败的回调
      if (data.code === 10000) {
        this.$message({
          message: data.msg,
          type: 'success'
        })
        this.getdamagedqueryBuBuHuoList() //  查询补货列表
        this.dialogPara.isShowDialog = false //  关闭弹出框
      } else {
        this.$message({
          message: data.msg,
          type: 'error'
        })
      }
    },
  },
}
</script>
<style lang="stylus" scoped>
#relen
  display flex
  justify-content flex-end
  .comond_btn
    display flex
    justify-content flex-end
    margin-bottom 30px
    button
      background-color #0a3d5f
      color #ff
.el-form-item
  display flex
.forBox {
  display flex
}
.disflexbtw {
  display flex
  justify-content space-between
}
</style>